export default function CtaSection() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden bg-background-100 border border-background-300/40">
          <div className="absolute inset-0 opacity-20">
            <img
              src="https://readdy.ai/api/search-image?query=dark%20abstract%20ink%20background%20of%20swirling%20crimson%20smoke%20and%20shadow%2C%20noir%20atmosphere%2C%20deep%20near-black%20with%20blood%20red%20and%20embers%2C%20moody%20cinematic%20texture&width=1400&height=600&seq=wai-cta-01&orientation=landscape"
              alt="歪歪漫画暗黑猎奇内容区背景"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-950/70 to-background-950/90"></div>

          <div className="relative px-6 md:px-12 py-12 md:py-16 text-center">
            <p className="text-xs tracking-widest text-accent-400 mb-3">立即入坑 · 一站看全</p>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-4">
              别让冷门佳作，错过它的读者
            </h2>
            <p className="text-sm md:text-base text-foreground-400 max-w-xl mx-auto mb-8">
              从暗黑心理到末日废土，从邪典经典到脑洞反转，歪歪漫画猎奇频道
              已为你整理好每一份非常规故事。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="#hot"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-600 hover:bg-primary-500 text-foreground-950 font-medium text-sm transition-colors whitespace-nowrap"
              >
                <i className="ri-book-open-line text-base"></i>
                开始阅读猎奇精选
              </a>
              <a
                href="#category"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-200/40 border border-background-400/40 hover:bg-background-200/60 text-foreground-200 font-medium text-sm transition-colors whitespace-nowrap"
              >
                <i className="ri-archive-2-line text-base"></i>
                浏览全部题材
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}